export * from './lib/clinic-services.module';
export * from './lib/services/clinic-video-player-overlay.service';
